import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailVerificationService {
  private emailVerifiedSubject = new BehaviorSubject<boolean>(false);
  emailVerified: Observable<boolean> = this.emailVerifiedSubject.asObservable();

  constructor() {
  }

  setEmailVerified(status: boolean) {
    this.emailVerifiedSubject.next(status);
  }
}
